module.exports = __webpack_public_path__ + "static/media/undraw_finance.2eff78d7.png";